import { FC } from 'react';

import { ICONS } from '@/svgs/Icons';

import styles from './EmptySearch.module.scss';
import { IEmptySearchProps } from './EmptySearch.types';

export const EmptySearch: FC<IEmptySearchProps> = ({ title, subtitle }) => (
  <div className={styles.container}>
    <div className={styles.icon}>{ICONS.magnifyingGlass.default}</div>
    <h4 className={styles.title}>{title}</h4>
    <p className={styles.message}>{subtitle}</p>
  </div>
);
